"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactUniversalComponent = _interopRequireDefault(require("react-universal-component"));

var _reactAccessibilityProvider = _interopRequireDefault(require("@nerdwallet/react-accessibility-provider"));

var _reactAccessibility = require("@nerdwallet/react-accessibility");

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Wrapper around faceyspacey's react-universal-component that renders a react-accessibility-provider around every codesplit component boundary
 * It does this so to ensure that codesplit component trees do not autogenerate ids that could clash or change depending on the timing of the rendering of that particular part of the tree.
 * See comment block at bottom of the file for a more detailed example.
 *
 * @param {*} asyncComponent - a dynamic import statement that resolves with a react Component definition passed to faceyspacey's react-universal-component
 * @param {*} options - options passed to faceyspacey's react-universal-component
 */
const universalComponentWithNerdwalletAccessibilityIntegration = (asyncComponent, options) => {
  const UniversalComponent = (0, _reactUniversalComponent.default)(asyncComponent, _objectSpread({
    // ignore babel renames to make sure server and client bundle names are the same
    // https://github.com/faceyspacey/babel-plugin-universal-import/issues/77#issuecomment-462768369
    ignoreBabelRename: true
  }, options));

  const UniversalComponentWithNerdwalletAccessibilityIntegration = props => {
    const asyncAccessibilityProviderPrefix = (0, _reactAccessibility.useId)();
    return (
      /*#__PURE__*/
      _react.default.createElement(_reactAccessibilityProvider.default, {
        prefix: asyncAccessibilityProviderPrefix
      },
      /*#__PURE__*/
      _react.default.createElement(UniversalComponent, props))
    );
  }; // keep any static defs from faceyspacey's UniversalComponent
  // (structured-content-core relies on UniversalComponent.preload()) for ssr timing


  (0, _hoistNonReactStatics.default)(UniversalComponentWithNerdwalletAccessibilityIntegration, UniversalComponent);
  return UniversalComponentWithNerdwalletAccessibilityIntegration;
};

var _default = universalComponentWithNerdwalletAccessibilityIntegration; // This came from a discussion we were having about the `async component loading` + react suspense/concurrent issue over in another PR.
// - https://github.com/NerdWallet/react-components/pull/2377#discussion_r479520116
//
// because of that uncertainty,
// wrapping a codesplit boundary with its own prefix
// keeps the ids in that space always clash-free
//
// i.e. consider an App with 5 components (A, B, C, D, E), each of them calling useId once to autogen an id.
//
// ```
// App
//   A: CLIENT_ID-1
//   B: CLIENT_ID-2
//   C: CLIENT_ID-3
//     (async) D: CLIENT_ID-4-1
//        A: CLIENT_ID-4-2
//        B: CLIENT_ID-4-3
//   (async) E: CLIENT_ID-5-1
//      D: CLIENT_ID-5-2
//        A: CLIENT_ID-5-3
//        B: CLIENT_ID-5-4
// ```
//
// each `(async)` boundary calls `useId` where it is deterministic,
// and uses that unique-id as the prefix,
// and starts a new counter for everything down below.
// i.e. `(async) D` and `(async) E` timing of module load and render does not matter.
// E could load before D or vice-versa

exports.default = _default;